module.exports = {
	"id": "AE",
	"name": "United Arab Emirates",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.00411,
			"11": 0.00822,
			"12": 0.00822,
			"13": null,
			"14": 0.00411,
			"15": null,
			"16": null,
			"17": 0.00411,
			"18": 0.00822,
			"19": 0.00822,
			"20": 0.01233,
			"21": 0.01233,
			"22": 0.03288,
			"23": 0.01233,
			"24": 0.00822,
			"25": 0.02055,
			"26": 0.02055,
			"27": 0.01644,
			"28": 0.00822,
			"29": 0.02877,
			"30": 0.02466,
			"31": 0.06987,
			"32": 0.01644,
			"33": 0.0411,
			"34": 0.05343,
			"35": 0.01644,
			"36": 0.02466,
			"37": 0.01233,
			"38": 0.03288,
			"39": 0.03288,
			"40": 0.02466,
			"41": 0.02055,
			"42": 0.03288,
			"43": 0.32058,
			"44": 0.05343,
			"45": 0.04932,
			"46": 0.03699,
			"47": 0.05343,
			"48": 0.05343,
			"49": 1.00284,
			"50": 0.10275,
			"51": 0.62883,
			"52": 0.29592,
			"53": 19.51428,
			"54": 4.51689,
			"55": 0.14796,
			"56": 0.0411,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.01644,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.00411,
			"11": 0.00411,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.01233,
			"23": 0.00822,
			"24": 0.00822,
			"25": null,
			"26": null,
			"27": 0.00411,
			"28": null,
			"29": 0.00411,
			"30": 0.00411,
			"31": 0.00411,
			"32": 0.01233,
			"33": 0.00822,
			"34": 0.00822,
			"35": 0.00822,
			"36": 0.00822,
			"37": 0.01233,
			"38": 0.04521,
			"39": 0.01233,
			"40": 0.01233,
			"41": 0.01644,
			"42": 0.00822,
			"43": 0.05754,
			"44": 0.03288,
			"45": 0.05343,
			"46": 0.06576,
			"47": 0.27537,
			"48": 0.22605,
			"49": 2.30982,
			"50": 0.18495,
			"51": null,
			"52": null,
			"3.5": 0.01233,
			"3.6": 0.01644
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.00822,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.00411,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.02055,
			"37": 0.0411,
			"38": 0.04932,
			"39": 0.02055,
			"40": 0.32469,
			"41": 0.04521,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.02055
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.02055,
			"6": 0.01233,
			"7": 0.0411,
			"8": 0.20961,
			"9": 0.19317,
			"10": 1.14258,
			"3.1": null,
			"3.2": null,
			"5.1": 0.05343,
			"6.1": 0.04932,
			"7.1": 0.01233,
			"9.1": 0.85899
		},
		"ios_saf": {
			"8": 0,
			"10": 6.84083039967,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.184352463572,
			"8.1-8.4": 0.340583364904,
			"9.0-9.2": 0.162480137386,
			"9.3": 2.47886363447
		},
		"android": {
			"3": 0,
			"4": 0.0414430749354,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00518038436693,
			"4.1": 0.149491091731,
			"4.2-4.3": 0.373727729328,
			"4.4": 0.856983585271,
			"4.4.3-4.4.4": 0.864384134367
		},
		"ie": {
			"6": null,
			"7": 0.00415372340426,
			"8": 0.323990425532,
			"9": 0.340605319149,
			"10": 0.236762234043,
			"11": 2.60853829787,
			"5.5": null
		},
		"op_mob": {
			"0": 0.22787257902,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00632979386166
		},
		"edge": {
			"12": 0.06987,
			"13": 0.36168,
			"14": 0.8631
		},
		"ie_mob": {
			"10": 0.0615546478873,
			"11": 0.250615352113
		},
		"bb": {
			"7": 0.061845,
			"10": null
		},
		"samsung": {
			"0": 3.4162
		},
		"and_uc": {
			"0": 19.34276
		},
		"op_mini": {
			"0": 3.07008762712
		},
		"and_chr": {
			"0": 21.15877
		},
		"and_ff": {
			"0": 0.02356
		}
	},
	"total": 98.749195
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AE.json
 ** module id = 456
 ** module chunks = 0
 **/